var React = require('react');

function CircleUnfilled12x12 (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"6","cy":"6","r":"5","stroke":"currentColor","strokeWidth":"2"}));
}

CircleUnfilled12x12.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = CircleUnfilled12x12;

CircleUnfilled12x12.default = CircleUnfilled12x12;
